export var AiReportEditMutationTypes;
(function (AiReportEditMutationTypes) {
    AiReportEditMutationTypes["INIT_STATE"] = "INIT_STATE";
    AiReportEditMutationTypes["FETCH_REPORT"] = "FETCH_REPORT";
    AiReportEditMutationTypes["SET_PROJECT_TITLE"] = "SET_PROJECT_TITLE";
    AiReportEditMutationTypes["SET_ADDRESS"] = "SET_ADDRESS";
    AiReportEditMutationTypes["SET_CONSTRUCTION_START_DATE"] = "SET_CONSTRUCTION_START_DATE";
    AiReportEditMutationTypes["SET_CONSTRUCTION_END_DATE"] = "SET_CONSTRUCTION_END_DATE";
    AiReportEditMutationTypes["SET_COST"] = "SET_COST";
    AiReportEditMutationTypes["SET_DESCRIPTION"] = "SET_DESCRIPTION";
    AiReportEditMutationTypes["UPDATE_FIELD"] = "UPDATE_FIELD";
})(AiReportEditMutationTypes || (AiReportEditMutationTypes = {}));
